import React, { useEffect, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectEmailContacts, selectEmailContactsLoading } from '../../store/emailHub/emailUsers'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { SelectDropdown, SelectOption } from '../SelectDropdown/SelectDropdown'
import { selectCustomEmailFilter, selectEmailFilterSender, selectShowEmailFilterModal, setEmailFilterSender } from '../../store/emailHub/emailFilters'
import { useFetchEmailThreads } from '../../views/EmailV2/hooks'
import { selectEmailThreadsLoading } from '../../store/emailHub/emailThreads'

export interface EmailDateFilterProps {
  disabled?: boolean
}

export const EmailContactFilter: React.FC<EmailDateFilterProps> = ({ disabled = false }) => {
  const dispatch = useAppDispatch()

  const contacts = useAppSelector(selectEmailContacts)
  const contactsLoading = useAppSelector(selectEmailContactsLoading)
  const showEmailFilterModal = useAppSelector(selectShowEmailFilterModal)
  const selectedSender = useAppSelector(selectEmailFilterSender)
  const customFilter = useAppSelector(selectCustomEmailFilter)
  const emailThreadsLoading = useAppSelector(selectEmailThreadsLoading)

  const { fetchEmailThreads } = useFetchEmailThreads()

  const [selectedContact, setSelectedContact] = useState<SelectOption | null>(null)

  const contactOptions = useMemo(() => {
    return contacts.map((contact) => {
      return { id: contact.email, label: getUserDisplayName(contact) }
    })
  }, [contacts])

  useEffect(() => {
    if (!contactOptions) {
      return
    }
    if (!selectedSender) {
      setSelectedContact(null)
    } else {
      const contact = contactOptions.find((option) => option.id === selectedSender)
      if (contact) {
        setSelectedContact(contact)
      }
    }
  }, [selectedSender, contactOptions])

  const handleContactSelected = async (option: SelectOption) => {
    const contact = contacts.find((contact) => contact.email === option.id)
    if (!contact) {
      return
    }
    dispatch(setEmailFilterSender(contact.email))
    if (!showEmailFilterModal) {
      await fetchEmailThreads({ filter: { ...customFilter, senders: [contact.email] } })
    }
  }

  return (
    <div className='d-flex flex-column gap-1'>
      <div className='lead-extra-small'>Filter by contact {selectedContact ? '(1)' : null}</div>
      <SelectDropdown
        initialSelectedOption={selectedContact}
        options={contactOptions}
        disabled={disabled}
        loading={emailThreadsLoading || contactsLoading}
        placeholder='Select a contact'
        onOptionSelected={handleContactSelected}
        searchable
      />
    </div>
  )
}
